<template>
	<div class="loader">
		<div class="wrapper">
			<i class="star"></i>
		</div>
		<span></span>
		<span></span>
		<span></span>
		<span></span>
		<span></span>
		<span></span>
	</div>
</template>

<script>
export default {
	name: "christmas-loader"
};
</script>

<style scoped lang="scss">
.loader {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 100px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}

.loader span {
	width: 100px;
	height: 20px;
	background: white;
	margin: 3px 1px;
	animation: loading 3s ease-in-out infinite forwards;
}

.star {
	background-color: transparent;
	margin: 50px 0;
	position: relative;
	display: block;
	color: #f6bd60;
	width: 0px;
	height: 0px;
	border-right: 100px solid transparent;
	border-bottom: 70px solid #f6bd60;
	border-left: 100px solid transparent;
	transform: rotate(35deg);
	animation: turn 6s ease-in-out infinite forwards;
}

.star:before {
	border-bottom: 80px solid #f6bd60;
	border-left: 30px solid transparent;
	border-right: 30px solid transparent;
	position: absolute;
	height: 0;
	width: 0;
	top: -45px;
	left: -65px;
	display: block;
	content: '';
	transform: rotate(-35deg);
}

.star:after {
	position: absolute;
	display: block;
	color: #f6bd60;
	top: 3px;
	left: -105px;
	width: 0px;
	height: 0px;
	border-right: 100px solid transparent;
	border-bottom: 70px solid #f6bd60;
	border-left: 100px solid transparent;
	transform: rotate(-70deg);
	content: '';
}

.star {
	transform: scale(0.3) rotate(35deg);
}

.wrapper {
	height: 120px;
}

.loader span:nth-child(2) {
	width: 20px;
	background: #87c38f;
	animation-delay: -3s;
}

.loader span:nth-child(3) {
	width: 40px;
	background: #226f54;
	animation-delay: -2.8s;
}

.loader span:nth-child(4) {
	width: 60px;
	background: #87c38f;
	animation-delay: -2.6s;
}

.loader span:nth-child(5) {
	width: 80px;
	background: #226f54;
	animation-delay: -2.4s;
}

.loader span:nth-child(6) {
	width: 100px;
	background: #87c38f;
	animation-delay: -2.2s;
}

.loader span:nth-child(7) {
	width: 20px;
	background: #603a23;
	animation: none
}

@keyframes loading {

	0% {
		transform: scaleX(1);
	}

	20% {
		transform: scaleX(0.6);
	}

	40% {
		transform: scaleX(0.6);
	}

	60% {
		transform: scaleX(0.6);
	}

	80% {
		transform: scaleX(1);
	}

	100% {
		transform: scaleX(1);
	}

}

@keyframes turn {
	0% {
		transform: scale(0.3) rotate(105deg);
	}

	20% {
		transform: scale(0.3) rotate(-35deg);
	}

	40% {
		transform: scale(0.3) rotate(-35deg);
	}

	60% {
		transform: scale(0.3) rotate(-35deg);
	}

	80% {
		transform: scale(0.3) rotate(105deg);
	}

	100% {
		transform: scale(0.3) rotate(105deg);
	}
}
</style>
